<template>
  <el-container style="height: 100vh;">
    <el-aside :width="isMobile ? '65px' : '230px'" v-if="!isFullScreen" >
      <Logo />
      <Menu style="flex: 1;" />
      <!-- <Bottom /> -->
    </el-aside>
    <el-container>
      <el-header>
        <Header v-if="!isFullScreen" />
        <Tags />
      </el-header>
      <el-main>
        <router-view v-slot="{ Component }">
          <keep-alive :include="this.$store.state.keepAlive.keepLiveRoute">
            <component :is="Component" :key="$route.path" v-if="$store.state.keepAlive.routeShow"/>
          </keep-alive>
        </router-view>
      </el-main>
    </el-container>
  </el-container>
</template>

<script>
import Logo from './logo/index.vue'
import Menu from './menu/index.vue'
import Bottom from './bottom/index.vue'
import Header from './header/index.vue'
import Tags from './tags/index.vue'
export default {
  data() {
		return {

    }
  },
  mounted() {
    window.onresize = () => {
      this.$store.commit('setMobile', document.documentElement.clientWidth <= 1000)
    }
  },
  computed:{
    isMobile(){
      return this.$store.state.app.isMobile;
    },
    isFullScreen(){
      return this.$store.state.app.isFullScreen;
    }
  },
  components: {
    Logo,
    Menu,
    Bottom,
    Header,
    Tags
  }
}
</script>

<style lang="scss" scoped>
.el-aside {
  height: 100%;
  display: flex;
  flex-direction: column;
  transition: 0.2s;
  overflow-x: hidden;
  transition: 0.3s;
  border-right: 1px solid #ebeef5;
  &::-webkit-scrollbar {
    width: 0 !important;
  }
  Logo{
    height: 100px;
  }
}
.el-header {
  padding-left: 0;
  padding-right: 0;
  height: 80px;
}
.el-main {
  height: 100%;
  padding: 0;
  background-color: var(--system-container-background);
}
</style>